import { MaterialPreparationSettingsView } from "./preparation-settings/MaterialPreparationSettingsView";
import { usePreparationSettingsWorkspace } from "./preparation-settings/usePreparationSettingsWorkspace";
export function MaterialPreparationSettings(props: Parameters<typeof usePreparationSettingsWorkspace>[0]) {
 const workspace = usePreparationSettingsWorkspace(props);
 return <MaterialPreparationSettingsView workspace={workspace} />;
}
